module.exports = __webpack_public_path__ + "static/media/polygon.43f210f4.svg";